// Ugly workaround which is needed to get three-mesh-bvh to compile in our code base. The issue is that three-mesh-bvh
// typings try to augment the three module by extending its functions and attributes. However, due to a bug
// (https://github.com/mrdoob/three.js/issues/19468) three cannot properly be augmented when three.d.ts is used.
// Therefore we import the transpiled js version of three-mesh-bvh and define our own typings in
// client/src/three-mesh-bvh.d.ts. So far we only defined the methods and attributes we actually use, however this
// might brake in the future. Also, if the IDE complains about a missing function, you probably have to add it in the
// three-mesh-bvh.d.ts yourself.
// Check https://github.com/gkjohnson/three-mesh-bvh for more information on acceleration structures
import { acceleratedRaycast, disposeBoundsTree, MeshBVH } from "three-mesh-bvh";
import { BufferGeometry, Mesh } from "three";
Mesh.prototype.raycast = acceleratedRaycast;
export class BVHBufferGeometry extends BufferGeometry {
    constructor(bufferGeometry) {
        super();
        this.computeBoundsTree = (options = {}) => {
            return this.computeBoundsTree(options);
        };
        this.copy(bufferGeometry);
        this.boundsTree = new MeshBVH(this);
    }
    disposeBoundsTreeLocal() {
        disposeBoundsTree.bind(this)();
    }
    dispose() {
        this.disposeBoundsTreeLocal();
        super.dispose();
    }
}
